<template>
    <div id="app">
        <!-- 访问密码验证 -->
        <AccessPassword />

        <PageHeader v-if="!hideHeader && !vuex_h5"></PageHeader>
        <pageHeaderMobile v-else />
        <router-view />
        <PageFoot v-if="!hideFoot"></PageFoot>

        <!-- 购物车弹窗 -->
        <cartWin></cartWin>

        <!-- 比较浮窗 -->
        <compareWin></compareWin>

        <!-- 快速浏览弹窗 -->
        <productQuickWinVue></productQuickWinVue>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PageHeader from '@/components/page-header.vue'
import pageHeaderMobile from '@/components/page-header-mobile.vue' //顶部搜索
import PageFoot from '@/components/page-foot.vue'
import cartWin from '@/components/cart-win.vue'
import productQuickWinVue from '@/components/product-quick-win.vue'
import AccessPassword from '@/components/AccessPassword.vue'
export default {
    components: {
        PageHeader,
        PageFoot,
        cartWin,
        productQuickWinVue,
        pageHeaderMobile,
        AccessPassword
    },
    data() {
        return {
            hideHeader: false,
            hideFoot: false,
        }
    },
    computed: {
        ...mapGetters(['vuex_h5']),
    },
    watch: {
        $route: {
            immediate: true,
            deep: true,
            handler(newV) {
                // 需要隐藏顶部栏和底部栏的页面
                let arr = [
                    '/login',
                    '/register',
                    '/register-relevance',
                    '/register-step1',
                    '/register-step2',
                    '/register-step3',
                    '/invite-coworker',
                    '/forgot-password',
                    '/emailCheck',
                ]
                if (arr.includes(newV.path)) {
                    this.hideHeader = true
                    this.hideFoot = true
                } else {
                    this.hideHeader = false
                    this.hideFoot = false
                }
            },
        },
    },
    created() {},
    mounted() {},
    methods: {
    },
}
</script>

<style lang="less">
.m_loading_style {
    z-index: 9999999;
}
@import '~@/assets/js/swiper-bundle.min.css';


</style>
